var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.text['0001']))]),_vm._v(" "),_c('p',{staticClass:"main-text"},[_vm._v("\n    "+_vm._s(_vm.text['0042'])+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"splash"},[_c('img',{staticClass:"splash",attrs:{"src":("/assets/img/splash_" + _vm.currentLanguage + ".png")},on:{"click":_vm.screenSplashNext}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b3ab89a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/Splash.vue
// module id = 29
// module chunks = 0